"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _orderViewConfigApi = require("@/api/orderViewConfigApi");
var XLSX = _interopRequireWildcard(require("xlsx"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UserFilterTab',
  data: function data() {
    var validatePhone = function validatePhone(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确'));
      } else {
        callback();
      }
    };
    return {
      configList: [],
      selectedConfigId: null,
      phoneList: [],
      tableLoading: false,
      addDialogVisible: false,
      showImportDialog: false,
      submitting: false,
      phoneForm: {
        phone: ''
      },
      phoneRules: {
        phone: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }]
      },
      fileList: [],
      previewPhones: []
    };
  },
  created: function created() {
    this.fetchConfigList();
  },
  methods: {
    fetchConfigList: function fetchConfigList() {
      var _this = this;
      (0, _orderViewConfigApi.getOrderViewConfigList)().then(function (res) {
        _this.configList = Array.isArray(res) ? res : [];
        if (_this.configList.length > 0 && !_this.selectedConfigId) {
          _this.selectedConfigId = _this.configList[0].id;
          _this.fetchPhoneList();
        }
      }).catch(function (err) {
        console.error('获取配置列表失败:', err);
        _this.configList = [];
      });
    },
    getConfigLabel: function getConfigLabel(item) {
      var name = item.appNames || '全部小程序';
      var days = item.viewDays && item.viewDays > 0 ? "\u8FD1".concat(item.viewDays, "\u5929") : '不限制';
      var status = item.enabled ? '启用' : '禁用';
      return "".concat(name, " - ").concat(days, "\uFF08").concat(status, "\uFF09");
    },
    handleConfigChange: function handleConfigChange() {
      this.fetchPhoneList();
    },
    fetchPhoneList: function fetchPhoneList() {
      var _this2 = this;
      if (!this.selectedConfigId) {
        this.phoneList = [];
        return;
      }
      this.tableLoading = true;
      (0, _orderViewConfigApi.getFilteredPhones)(this.selectedConfigId).then(function (res) {
        _this2.phoneList = Array.isArray(res) ? res : [];
      }).catch(function (err) {
        console.error('获取手机号列表失败:', err);
        _this2.phoneList = [];
      }).finally(function () {
        _this2.tableLoading = false;
      });
    },
    handleAddPhone: function handleAddPhone() {
      this.phoneForm.phone = '';
      this.addDialogVisible = true;
    },
    handleDeletePhone: function handleDeletePhone(index) {
      var _this3 = this;
      var phone = this.phoneList[index];
      this.$confirm("\u786E\u8BA4\u5220\u9664\u624B\u673A\u53F7 ".concat(phone, " \u5417\uFF1F\u5220\u9664\u540E\u8BE5\u7528\u6237\u5C06\u6062\u590D\u67E5\u770B\u8BA2\u5355\u6743\u9650\u3002"), '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var newList = _this3.phoneList.filter(function (_, i) {
          return i !== index;
        });
        _this3.submitPhones(newList).then(function () {
          _this3.$message.success('删除成功');
          _this3.phoneList = newList;
        });
      }).catch(function () {});
    },
    handleClearAll: function handleClearAll() {
      var _this4 = this;
      if (!this.selectedConfigId) return;
      this.$confirm('确认清空全部过滤手机号？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _orderViewConfigApi.clearFilteredPhones)(_this4.selectedConfigId).then(function () {
          _this4.$message.success('清空成功');
          _this4.phoneList = [];
        }).catch(function (err) {
          console.error('清空失败:', err);
          _this4.$message.error('清空失败');
        });
      }).catch(function () {});
    },
    handleAddPhoneSubmit: function handleAddPhoneSubmit() {
      var _this5 = this;
      this.$refs.phoneForm.validate(function (valid) {
        if (!valid) return;
        var phone = _this5.phoneForm.phone.trim();
        // 场景1 & 3：检查是否已存在于列表或待导入预览中
        var allPhones = [].concat(_toConsumableArray(_this5.phoneList), _toConsumableArray(_this5.previewPhones));
        if (allPhones.includes(phone)) {
          _this5.$message.warning('该手机号已存在，请勿重复添加');
          return;
        }
        // 同时更新预览（防止先预览再添加同一手机号）
        if (!_this5.previewPhones.includes(phone)) {
          _this5.previewPhones = [].concat(_toConsumableArray(_this5.previewPhones), [phone]);
        }
        var newList = [].concat(_toConsumableArray(_this5.phoneList), [phone]);
        _this5.submitPhones(newList).then(function () {
          _this5.$message.success('添加成功');
          _this5.phoneList = newList;
          _this5.addDialogVisible = false;
        });
      });
    },
    handleExport: function handleExport() {
      var _this6 = this;
      if (!this.selectedConfigId) return;
      (0, _orderViewConfigApi.exportFilteredPhones)(this.selectedConfigId).then(function (res) {
        var fileName = res.fileName;
        window.open(fileName, '_blank');
      }).catch(function (err) {
        console.error('导出失败:', err);
        _this6.$message.error('导出失败');
      });
    },
    submitPhones: function submitPhones(phones) {
      var _this7 = this;
      return (0, _orderViewConfigApi.setFilteredPhones)(this.selectedConfigId, phones).catch(function (err) {
        console.error('保存手机号失败:', err);
        _this7.$message.error('保存失败');
        throw err;
      });
    },
    handleFileChange: function handleFileChange(file, files) {
      this.fileList = files.slice(-1);
      this.parseFile(file.raw);
    },
    handleFileRemove: function handleFileRemove() {
      this.fileList = [];
      this.previewPhones = [];
    },
    parseFile: function parseFile(file) {
      var _this8 = this;
      if (!file) return;
      var reader = new FileReader();
      var ext = file.name.split('.').pop().toLowerCase();
      reader.onload = function (e) {
        try {
          var phones = [];
          if (ext === 'txt' || ext === 'csv') {
            var text = e.target.result;
            phones = text.split(/[\r\n,，;；\t]+/).map(function (p) {
              return p.trim();
            }).filter(function (p) {
              return p.length > 0;
            });
          } else if (ext === 'xlsx' || ext === 'xls') {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, {
              type: 'array',
              cellDates: true,
              cellNF: true
            });
            var sheetNames = workbook.SheetNames;
            var allSheets = [];
            for (var i = 0; i < sheetNames.length; i++) {
              var sheet = workbook.Sheets[sheetNames[i]];
              var json = XLSX.utils.sheet_to_json(sheet, {
                header: 1,
                defval: ''
              });
              allSheets.push.apply(allSheets, _toConsumableArray(json));
            }
            var raw = [];
            for (var _i = 0; _i < allSheets.length; _i++) {
              var row = allSheets[_i];
              if (Array.isArray(row)) {
                for (var j = 0; j < row.length; j++) {
                  var val = row[j];
                  if (val !== null && val !== undefined && val !== '') {
                    raw.push(String(val).trim());
                  }
                }
              }
            }
            phones = raw;
          }
          phones = phones.filter(function (p) {
            return /^1[3-9]\d{9}$/.test(p.trim());
          });
          _this8.previewPhones = phones;
        } catch (err) {
          console.error('文件解析失败:', err);
          _this8.$message.error('文件解析失败');
          _this8.previewPhones = [];
        }
      };
      reader.onerror = function () {
        _this8.$message.error('文件读取失败');
      };
      var fileToRead = file.raw instanceof Blob ? file.raw : file;
      if (ext === 'xlsx' || ext === 'xls') {
        reader.readAsArrayBuffer(fileToRead);
      } else {
        reader.readAsText(fileToRead);
      }
    },
    handleImportSubmit: function handleImportSubmit() {
      var _this9 = this;
      if (this.previewPhones.length === 0) {
        this.$message.warning('请先选择文件');
        return;
      }
      var existingSet = new Set(this.phoneList.map(function (p) {
        return p.trim();
      }));
      var newPhones = this.previewPhones.filter(function (p) {
        return !existingSet.has(p.trim());
      });
      var duplicateCount = this.previewPhones.length - newPhones.length;
      if (newPhones.length === 0) {
        this.$message.warning('所有手机号均已存在，无需重复导入');
        return;
      }
      this.submitting = true;
      (0, _orderViewConfigApi.importFilteredPhones)(this.selectedConfigId, newPhones).then(function (count) {
        var msg = "\u6210\u529F\u5BFC\u5165 ".concat(count, " \u4E2A\u624B\u673A\u53F7");
        if (duplicateCount > 0) {
          msg += "\uFF08\u53E6\u6709 ".concat(duplicateCount, " \u4E2A\u91CD\u590D\u624B\u673A\u53F7\u5DF2\u8DF3\u8FC7\uFF09");
        }
        _this9.$message.success(msg);
        _this9.closeImportDialog();
        _this9.fetchPhoneList();
      }).catch(function (err) {
        console.error('导入失败:', err);
        _this9.$message.error('导入失败');
      }).finally(function () {
        _this9.submitting = false;
      });
    },
    closeImportDialog: function closeImportDialog() {
      this.showImportDialog = false;
      this.fileList = [];
      this.previewPhones = [];
    },
    refreshData: function refreshData() {
      if (this.selectedConfigId) {
        this.fetchPhoneList();
      }
      this.fetchConfigList();
    }
  }
};